export default function Typography({
  children,
  align = "left",
  family = "sans",
  size = "16",
  desktopSize = "",
  weight = "",
  color = "black",
  underline = false,
  clampValue = "",
  onClick = undefined,
  noWrap = false,
  truncate = false,
}) {
  const sizeClasses = {
    8: "text-[8px] leading-[normal]",
    10: "text-[10px] leading-[normal]",
    12: "text-[12px] leading-[normal]",
    16: "text-[16px] leading-[normal]",
    20: "text-[20px] leading-[normal]",
    24: "text-[24px] leading-[normal]",
    28: "text-[28px] leading-[normal]",
    32: "text-[32px] leading-[normal]",
    36: "text-[36px] leading-[normal]",
    40: "text-[40px] leading-[normal]",
    44: "text-[44px] leading-[normal]",
    48: "text-[48px] md:leading-[50px] leading-[50px]",
    64: "text-[64px] md:leading-[64px]",
  };

  return (
    <span
      className={`text-${align} ${sizeClasses[size]} ${desktopSize ? `md:${sizeClasses[desktopSize] || ""}` : ""} ${weight ? `font-${weight}` : ""} text-${color} font-${family} ${underline ? "underline cursor-pointer" : ""} ${clampValue ? "line-clamp-" + clampValue : ""} ${noWrap ? "whitespace-nowrap" : ""} ${truncate ? "truncate text-ellipsis" : ""}`}
      onClick={onClick}
    >
      {children}
    </span>
  );
}